﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

// The default control for an external login provider.

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import React from "react";
import { ActionLink, RouteLink } from "~base/Components/Primitives/Link";
import { LoginPageCustomizations } from "../Customization";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import Button from "~base/Components/Primitives/Button";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

interface ExternalLoginProviderProps {
    name: string;
    customizations: LoginPageCustomizations;
}

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

export const ExternalLoginProvider: React.FunctionComponent<
    ExternalLoginProviderProps
> = ({ name, customizations }) => {
    const classes = useAdditionalStyles(customizations);

    const separator = window.location.href.includes("?") ? "&" : "?";
    const target = window.location.href + separator + "provider=" + name;

    const control = customizations.externalLoginControls?.[name];

    if (control) {
        return control;
    }

    const displayName =
        customizations.externalLoginDisplayNames?.[name] ?? name;

    return (
        <Button
            buttonClassName={classes.button}
            styleType={"DefaultPadded"}
            onClick={() => (window.location.href = target)}
        >
            {displayName}
        </Button>
    );
};

//-------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------

const useAdditionalStyles = (customizations?: LoginPageCustomizations) =>
    createUseStyles(
        (theme: ConsilioBaseTheme) => {
            return {
                button: {
                    marginBottom: "20px",
                    minWidth: "306px",
                },
            };
        },
        { name: "ExternalLoginProvider" }
    )();
